import { render } from "./SelfAuthentication.vue?vue&type=template&id=7911461d&scoped=true"
import script from "./SelfAuthentication.vue?vue&type=script&lang=js"
export * from "./SelfAuthentication.vue?vue&type=script&lang=js"

import "./SelfAuthentication.vue?vue&type=style&index=0&id=7911461d&scoped=true&lang=css"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7911461d"]])

export default __exports__